import React from 'react';
import {
    NSCard, NSInput, NSInputNumberStepper, NSLabel,
} from 'bricks';
import { format, parseISO } from 'date-fns';
import { FORM_LABEL_CLASS_NAME, ProjectActualsDiscrepanciesEnum } from 'views/ProFormaTable/constants';
import RenderIf from 'components/RenderIf/RenderIf';
import ProjectActualsIcon from 'views/ProFormaTable/components/ProjectActualsIcon/ProjectActualsIcon';
import { IProFormaValues } from 'views/ProFormaTable/types';
import MetricOutputCard from 'views/ProFormaTable/components/MetricOutputCard/MetricOutputCard';

interface ProFormaKeyDatesProps {
    shouldUseProjectActuals: boolean;
    actualsDiscrepancies?: ProjectActualsDiscrepanciesEnum[];
    values: IProFormaValues;
    formatDateForMonthInput: (date: string) => string;
    handleInputChange: (name: string, value: string) => void;
    handleDateChange: (
        field: string,
        value: string,
        values: { startDate: string; saleDate: string },
        handleUpdateProForma: (keyValues: any[], successCallback?: () => void) => void
    ) => void;
    handleUpdateProForma: (keyValues: any[], successCallback?: () => void) => void;
}

const ProFormaKeyDates = ({
    shouldUseProjectActuals,
    actualsDiscrepancies,
    values,
    formatDateForMonthInput,
    handleInputChange,
    handleDateChange,
    handleUpdateProForma,
}: ProFormaKeyDatesProps) => (
    <NSCard className="p-3 NSCard--level-2">
        <div className="d-flex flex-row w-100 align-items-start">
            <div className="d-flex flex-column w-50">
                <div className="d-flex pb-3 w-100">
                    <div className="d-flex col-4 pl-0">
                        <RenderIf isTrue={shouldUseProjectActuals && actualsDiscrepancies?.includes(ProjectActualsDiscrepanciesEnum.PRO_FORMA_START_DATE)}>
                            <ProjectActualsIcon
                                name={ProjectActualsDiscrepanciesEnum.PRO_FORMA_START_DATE}
                                className="my-auto mr-1"
                            />
                        </RenderIf>
                        <NSLabel className={FORM_LABEL_CLASS_NAME}>Start month</NSLabel>
                    </div>
                    <NSInput
                        type="month"
                        name="startDate"
                        value={formatDateForMonthInput(values.startDate)}
                        onChange={(event: React.ChangeEvent<HTMLInputElement>) => handleInputChange(event.target.name, event.target.value)}
                        onBlur={() => handleDateChange('startDate', values.startDate, values, handleUpdateProForma)}
                    />
                </div>
                <div className="d-flex w-100 pb-3">
                    <NSLabel className={FORM_LABEL_CLASS_NAME}>Construction start</NSLabel>
                    <NSInput
                        type="month"
                        name="constructionStart"
                        value={formatDateForMonthInput(values.constructionStart || '')}
                        onChange={(event: React.ChangeEvent<HTMLInputElement>) => handleInputChange(event.target.name, event.target.value)}
                        onBlur={() => handleDateChange('constructionStart', values.constructionStart || '', values, handleUpdateProForma)}
                    />
                </div>
                <div className="d-flex w-100 pb-3">
                    <NSLabel className={FORM_LABEL_CLASS_NAME}>Construction duration</NSLabel>
                    <NSInputNumberStepper
                        name="constructionDuration"
                        value={values.constructionDuration || null}
                        onChange={(count: number) => {
                            handleUpdateProForma([{ key: 'constructionDuration', value: String(count) }]);
                            handleInputChange('constructionDuration', String(count));
                        }}
                        customSuffix={(values.constructionDuration || 0) > 1 ? 'months' : 'month'}
                        min={1}
                        step={1}
                    />
                </div>
                <div className="d-flex w-100">
                    <NSLabel className={FORM_LABEL_CLASS_NAME}>Hold period</NSLabel>
                    <NSInputNumberStepper
                        name="holdPeriod"
                        value={values.holdPeriod || null}
                        onChange={(count: number) => {
                            handleUpdateProForma([{ key: 'holdPeriod', value: String(count) }]);
                            handleInputChange('holdPeriod', String(count));
                        }}
                        customSuffix={(values.holdPeriod || 0) > 1 ? 'months' : 'month'}
                        min={1}
                        step={1}
                    />
                </div>
            </div>
            <div className="d-flex flex-column justify-content-start ml-3 w-50">
                <MetricOutputCard
                    label="Sale month"
                    value={values.saleDate ? format(parseISO(values.saleDate), 'MMMM yyyy') : ''}
                    showInProgress={!values.saleDate}
                />
            </div>
        </div>
    </NSCard>
);

export default ProFormaKeyDates;
